/* eslint-disable react/prop-types */
import React, { useMemo } from "react";
import PropTypes from "prop-types";
import Paginator from "../Paginator/Paginator";
import styles from "./exhibition-table.module.less";
import ExhibitionTableRow from "./ExhibitionTableRow/ExhibitionTableRow";
import { Form } from "antd";
import dayjs from "dayjs";
import { useSelector } from "react-redux";
import CreateExhibitionPanel from "../CreateExhibitionPanel";
import { useEffect } from "react";
import { useState } from "react";
import { exhibitionAPI } from "../../api/api";
import { useLocation } from "react-router-dom";
import { notificationsFeedAPI } from "../../api/api";
import { setExhibitionInitialValues, setSavedExhibition } from "../../store/exhibitionSlice";
import { useDispatch } from "react-redux";

const ExhibitionTable = ({
  handleOpenModal,
  tableData,
  setShowCreateExhibitionPanel,
  sorting = {},
  current,
  pageSize,
  onChange,
  handleSort = () => {},
  total,
  setStandInfo,
  /* form, */
  onFinish,
  clearImage,
  passageDiagram,
  setPassageDiagram,
  isLogoDeleted,
  setExhibitionForDelete,
  isArchive = false,
  setRefreshEditingValues,
  refreshEditingValues,
  showCreateExhibitionPanel = false,
  fetchExhibitionData,
  setCurrentItem = () => {},
  setIsImageDeleted,
  isImageDeleted,
  closePanel,
  handleEdit,
  savedEditData,
  fetchingAfterSave,
  prevSavedEditData,
  className
}) => {
  const dispatch = useDispatch();
  const {
    editStandId,
    editExhibitionId,
    isEditMode,
    loading,
    savedExhibition,
    exhibitionInitialValues
  } = useSelector((state) => state.exhibitions);
  const { isAdmin } = useSelector((state) => state.auth);
  const [editindExhibition, setEditingExhibition] = useState();
  const [editingStand, setEditingStand] = useState();
  const [errors, setErrors] = useState([]);
  const [standDescription, setStandDescription] = useState("");
  const { user } = useSelector((state) => state.auth);
  const { pathname } = useLocation();
  const [creatorData, setCreatorData] = useState({});
  const isUserExhibition =
    user.id === creatorData?.creator?.id && creatorData?.creatorType !== "admin";

  const unreadExhibition =
    tableData.length && tableData.filter((obj) => obj.act).map((obj) => obj.id);
  const standArray = tableData.length && tableData.map((exhibition) => exhibition?.stands?.[0]);
  const unreadStand =
    tableData.length && standArray?.filter((obj) => obj?.act).map((obj) => obj.id);

  useEffect(() => {
    if (unreadExhibition.length && !isAdmin) {
      notificationsFeedAPI.markNotificationsAsReadNew(unreadExhibition, "exhibition");
    }
    if (unreadStand.length) {
      notificationsFeedAPI.markNotificationsAsReadNew(unreadStand, "stand");
    }
  }, [unreadExhibition.length, unreadStand.length]);

  const unsetFromPlatfrom = async (findEditingExhibition) => {
    const isBA1Page = pathname.includes("edit-and-view-exhibition");
    let findStandEditing = {};
    if (!isBA1Page) {
      findStandEditing = findEditingExhibition.stands.find((stand) => stand.id === editStandId);
    }

    const { boothNumber, description, isVisible, passageDiagram } = findStandEditing;
    const {
      areaName,
      city,
      cityId,
      logo,
      countryId,
      endDate,
      exhibitionName,
      isPrivate,
      startDate,
      website
    } = findEditingExhibition;

    const exhibitionValue = {
      areaName: areaName,
      description: description,
      cityId: cityId,
      countryId: countryId,
      startDate: startDate,
      endDate: endDate,
      logo: logo,
      exhibitionName: exhibitionName,
      times: findEditingExhibition.times?.map((t) => {
        return {
          startTime: t?.startTime,
          endTime: t?.endTime
        };
      }),
      isPrivate: isPrivate,
      website: website
    };

    const standValue = {
      boothNumber,
      description,
      isVisible,
      passageDiagram
    };
    if (isBA1Page) {
      exhibitionValue.description = findEditingExhibition.description;
    }

    if (!passageDiagram) {
      standValue.passageDiagram = "";
    }

    if (!logo) {
      exhibitionValue.logo = "";
    }

    if (isUserExhibition || (isAdmin && !pathname.includes("/admin-panel/users-list"))) {
      await exhibitionAPI.editExhibitionById(editExhibitionId, {
        ...exhibitionValue,
        sendModeration: false
      });
    }
    if (!isBA1Page) {
      await exhibitionAPI.editStandById(editStandId, { ...standValue, sendModeration: false });
    }
    fetchExhibitionData();
  };

  useEffect(() => {
    if (isEditMode || (refreshEditingValues && !fetchingAfterSave)) {
      const findEditingExhibition = tableData.find((item) => item.id === editExhibitionId);
      const creator = findEditingExhibition?.creator;
      const creatorType = findEditingExhibition?.creatorType;
      console.log(findEditingExhibition);
      setCreatorData({ creator, creatorType });
      setEditingExhibition(findEditingExhibition);
      (!savedEditData || prevSavedEditData?.exhibitionId !== savedEditData.exhibitionId) &&
        unsetFromPlatfrom(findEditingExhibition);
      if (refreshEditingValues) setRefreshEditingValues(false);
    }
  }, [isEditMode, editExhibitionId, fetchingAfterSave, refreshEditingValues]);

  useEffect(() => {
    const findEditingStand = editindExhibition?.stands?.find((stand) => stand.id === editStandId);
    setEditingStand(findEditingStand);
    setStandDescription(editingStand?.description);
  }, [editindExhibition, isEditMode, editStandId]);

  const handleErrors = (errorFields) => {
    errorFields.forEach(({ name, errors }) => {
      const errorField = name.at(-1);
      if (errors?.length === 0 || (errors?.length === 1 && errors[0].length === 0)) {
        setErrors((prevErrors) => {
          return { ...prevErrors, [errorField]: false };
        });
        return;
      }
      setErrors((prevErrors) => {
        return { ...prevErrors, [errorField]: true };
      });
    });
  };

  return (
    <>
      <section
        id="wrapper"
        className={`${className} ${styles.wrapper}`}
        style={{
          display:
            !isAdmin && tableData.length === 0 && !showCreateExhibitionPanel ? "none" : "block",
          overflow: isAdmin ? "" : "hidden"
        }}
      >
        <section className={styles.scrollable} style={{ minWidth: "auto" }}>
          {tableData?.map((item, index) => {
            return (
              <ExhibitionTableRow
                item={item}
                isAdmin={isAdmin}
                errors={errors}
                onFinish={onFinish}
                handleErrors={handleErrors}
                setCurrentItem={setCurrentItem}
                setErrors={setErrors}
                isFirstElement={index === 0}
                handleOpenModal={handleOpenModal}
                sorting={sorting}
                editingStand={editingStand}
                editindExhibition={editindExhibition}
                handleSort={handleSort}
                setStandInfo={setStandInfo}
                clearImage={clearImage}
                passageDiagram={passageDiagram}
                setPassageDiagram={setPassageDiagram}
                isLogoDeleted={isLogoDeleted}
                isArchive={isArchive}
                standDescription={standDescription}
                setExhibitionForDelete={setExhibitionForDelete}
                setIsImageDeleted={setIsImageDeleted}
                isImageDeleted={isImageDeleted}
                isUserExhibition={isUserExhibition}
                handleEdit={handleEdit}
                initialValues={exhibitionInitialValues}
              />
            );
          })}
          {/* {tableData?.map((item, index) => {
            console.log(item.id !== editExhibitionId, item.id, editExhibitionId);
            return (
              editExhibitionId && (
                <Form
                  key={`${item.id}_${index}`}
                  form={editExhibitionId == item.id ? form : null}
                  labelAlign="left"
                  onFinish={onFinish}
                  onFinishFailed={({ errorFields }) =>
                    item.id === editExhibitionId && handleErrors(errorFields)
                  }
                  scrollToFirstError
                  onClick={() => setCurrentItem(item)}
                  name={`edtiExhibitionFormTable_${item.id === editExhibitionId}`}
                  autoComplete="off"
                  requiredMark={false}
                  validateTrigger={"onSubmit"}
                  initialValues={{
                    ...exhibitionInitialValues
                  }}
                >
                  <ExhibitionTableRow
                    item={item}
                    isAdmin={isAdmin}
                    errors={errors}
                    setErrors={setErrors}
                    isFirstElement={index === 0}
                    handleOpenModal={handleOpenModal}
                    sorting={sorting}
                    handleSort={handleSort}
                    form={form}
                    setStandInfo={setStandInfo}
                    clearImage={clearImage}
                    passageDiagram={passageDiagram}
                    setPassageDiagram={setPassageDiagram}
                    isArchive={isArchive}
                    standDescription={standDescription}
                    setExhibitionForDelete={setExhibitionForDelete}
                    setIsImageDeleted={setIsImageDeleted}
                    isImageDeleted={isImageDeleted}
                    isUserExhibition={isUserExhibition}
                    handleEdit={handleEdit}
                    initialValues={exhibitionInitialValues}
                  />
                </Form>
              )
            );
          })} */}
          {!isAdmin && !isArchive && (
            <div style={{ display: showCreateExhibitionPanel ? "block" : "none" }}>
              <CreateExhibitionPanel
                setShowCreateExhibitionPanel={setShowCreateExhibitionPanel}
                num={tableData.length + 1}
                showCreateExhibitionPanel={showCreateExhibitionPanel}
                fetchData={fetchExhibitionData}
                closePanel={closePanel}
              />
            </div>
          )}
        </section>
      </section>
      <Paginator
        pagination={{ current, pageSize }}
        setCurrentPage={onChange}
        total={total}
        style={{ justifyContent: "center", marginTop: 24 }}
      />
    </>
  );
};

ExhibitionTable.propTypes = {
  handleOpenModal: PropTypes.func,
  tableData: PropTypes.array,
  lang: PropTypes.string,
  t: PropTypes.func,
  sorting: PropTypes.object,
  current: PropTypes.number,
  pageSize: PropTypes.number,
  total: PropTypes.number,
  onChange: PropTypes.func,
  setStandInfo: PropTypes.func,
  handleSort: PropTypes.func,
  onFinish: PropTypes.func,
  form: PropTypes.any,
  clearImage: PropTypes.func,
  passageDiagram: PropTypes.string,
  setPassageDiagram: PropTypes.func
};

export default ExhibitionTable;
